export default {
  ROOT_URL: 'https://conversional.local:8000',
  sentry: 'https://6a99474d26cb411395b5f81a07eba4c8@o236458.ingest.sentry.io/1452146',
  GA_ID: 'U-xxxxx',
  STUDIO_URL: 'http://conversional.local:3400/',
};
